import styled from "styled-components";
import Typography from "../../shared/typography/Typography";

export const StyledLabel = styled(Typography)`
  margin-bottom: 8px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    font-weight: 700 !important;
  }
`;